module.exports = __webpack_public_path__ + "static/media/2J.89304606.svg";